import { monthLabel } from '../../../shared/stats';

export function greeting(): string {
  const hour = new Date().getHours();
  return hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
}
export function targetPeriodAbbr(period: 'month' | 'quarter', periodKey: string): string {
  if (period === 'month') return monthLabel(periodKey).toUpperCase();
  return periodKey.split(' ')[1] ?? periodKey;
}
/** "$18.6k" — compact strip money, one decimal only when it isn't a round
    thousand (distinct from Stats' axisMoney, which never shows a decimal). */
export function compactMoney(cents: number): string {
  const dollars = cents / 100;
  if (Math.abs(dollars) < 1000) return `$${Math.round(dollars)}`;
  const k = Math.round((dollars / 1000) * 10) / 10;
  return `$${Number.isInteger(k) ? k.toFixed(0) : k.toFixed(1)}k`;
}
export function relTime(ms: number): string {
  const mins = Math.floor((Date.now() - ms) / 60000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
}
